import { ERROR_MESSAGE } from "../constants";

export const fabricSettingsValidation = (props: any): any => {
  let formErrors: any = {};
  let formValid: any = true;

  const { threshold } = props;
  const numericThreshold = Number(threshold);

  if (threshold === "" || threshold === null || threshold === undefined) {
    formValid = false;
    formErrors["threshold"] = ERROR_MESSAGE.THRESHOLD_REQUIRED;
  } else if (!Number.isFinite(numericThreshold) || numericThreshold <= 0) {
    formValid = false;
    formErrors["threshold"] = ERROR_MESSAGE.THRESHOLD_POSITIVE;
  }

  return { formValid, formErrors };
};
